var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('actions-toolbar'),_vm._v(" "),_c('v-divider'),_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"my-2 d-flex"},[_c('span',{staticClass:"headline ml-2"},[_vm._v(_vm._s(_vm.conversation.subject))]),_c('v-spacer'),_c('expand-collapse-messages')],1)],1),_c('div',[_c('message-list-container')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }